import { PayloadAction } from "@reduxjs/toolkit";

import { DriversState } from '../../types';

export const setAddingDriverFuelAssignmentStatus = (
  state: DriversState,
  action: PayloadAction<DriversState['fuelAssignment']['addingStatus']>
) => {
  state.fuelAssignment.addingStatus = action.payload;
};
